import {
  Component,
  DoCheck,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { DatePipe } from '@angular/common';
import { DataManagementAppService } from 'src/app/services/data-management-app.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-data-configuration',
  template: `
    <div class="dc-page">
      <div class="wiz">
        <div class="backlink" [routerLink]="goBack['additional']['route']">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>
          {{ goBack['additional']['title'] }}
        </div>

        <div class="wiz-hd">
          <span class="nm">{{ dataSourceName | textpretty }}</span>
          <span class="sp"></span>
          <span class="meta">
            Created: {{ createdDate | date : 'medium' }}<br />
            Last Updated: {{ lastUpdatedDate | date : 'medium' }}
          </span>
        </div>

        <mat-stepper
          (selectionChange)="selectionChanged($event)"
          class="dc-stepper"
          labelPosition="bottom"
          [linear]="true"
          #stepper
        >
          <ng-template matStepperIcon="edit">
            <mat-icon>done</mat-icon>
          </ng-template>

          <mat-step
            *ngFor="let step of steps; let i = index"
            [completed]="step.status"
          >
            <form>
              <ng-template matStepLabel
                >{{ step['title'] }}
                <span
                  *ngIf="step.status"
                  class="dc-step-dt"
                  ><br />
                  {{ step.updatedDate | date : 'medium' }}</span
                >
              </ng-template>
            </form>
          </mat-step>
        </mat-stepper>

        <div class="wiz-body">
          <router-outlet (activate)="onChildActivated($event)"></router-outlet>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./data-configuration.component.scss'],
})
export class DataConfigurationComponent implements OnInit, DoCheck, OnDestroy {
  @Input() index: number = 0;
  @ViewChild('stepper') stepper: MatStepper | undefined;

  createdDate: Date | undefined;
  lastUpdatedDate: Date | undefined;
  dataSourceName: string = '';
  dataSource: any;
  dataSourceType: string = '';
  goBack: any = {
    additional: {
      title: 'Add Data Sources',
      route: '../data_sources',
    },
  };
  steps = [
    {
      title: 'Pull Configuration',
      route: 'data_pull',
      status: true,
      updatedDate: '',
      stepName: 'preview',
    },
    {
      title: 'Preview',
      route: 'data_preview',
      status: false,
      updatedDate: '',
      stepName: 'preview',
    },
    {
      title: 'Save',
      route: 'save',
      status: false,
      updatedDate: '',
      stepName: 'save',
    },
  ];

  parentUrl = '/data_management/data_configuration';
  selectedStepIndex: number = 0;
  private routeSubscription: Subscription | undefined;
  constructor(
    private dataManagementServices: DataManagementAppService,
    private router: Router,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}
  myDate = new Date();
  ngOnInit(): void {
    this.routeSubscription = this.route.firstChild?.paramMap.subscribe(
      (params: ParamMap) => {
        const dataName = params.get('data_name');
        if (dataName !== null) {
          this.dataSourceName = dataName;
        }
      }
    );
    if (!this.dataSourceName) {
      this.router.navigate(['../data_sources'], {
        relativeTo: this.route,
      });
    } else {
      this.dataSourceType = this.dataManagementServices.getDataSetType();
      this.selectedStepIndex = 0;
      this.getDataEntry();
      this.getAllCacheStatus();
    }
  }

  ngDoCheck(): void {
    this.routeSubscription = this.route.firstChild?.paramMap.subscribe(
      (params: ParamMap) => {
        const dataName = params.get('data_name');
        if (dataName !== null) {
          this.dataSourceName = dataName;
        }
      }
    );
  }

  ngOnDestroy(): void {
    // Unsubscribe if routeSubscription is defined
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  module_keys = ['default', 'additional'];
  selectionChanged($event: any): void {
    this.selectedStepIndex = $event.selectedIndex;
    switch ($event.selectedIndex) {
      case 0:
        this.router.navigate(['./data_pull', this.dataSourceName], {
          relativeTo: this.route,
        });
        break;
      case 1:
        this.router.navigate(['./data_preview', this.dataSourceName], {
          relativeTo: this.route,
        });
        break;
      case 2:
        this.router.navigate(['./save', this.dataSourceName], {
          relativeTo: this.route,
        });
        break;
    }
  }

  getDataEntry() {
    if (this.dataSourceName && this.dataSourceName != 'Configure DataSet') {
      this.dataManagementServices
        .getDataManagemententry(this.dataSourceName)
        .subscribe({
          next: (data) => {
            this.createdDate = data?.created_dtm
            this.lastUpdatedDate = data?.updated_dtm
            this.steps[0].status = true;
          },
          error: (error) => {
            console.debug(error);
          },
        });
    }
  }

  getCachedData(element: any) {
    this.dataManagementServices
      .getCacheStatus(this.dataSourceName, element.stepName)
      .subscribe((result: any) => {
        if (result['is_exist']) {
          element.status = true;
          element.updatedDate = result['updated_dtm'];
        }
      });
    return element;
  }

  getAllCacheStatus() {
    for (const element of this.steps) {
      this.getCachedData(element);
    }
  }

  onChildActivated(component: any) {
    component.dataChanged.subscribe((data: number) => {
      this.index = data;
      this.steps[0] = this.getCachedData(this.steps[0]);
      if (data == 1 || data == 3) {
        this.steps[data] = this.getCachedData(this.steps[data]);
        for (let i = data + 1; i < this.steps.length; i++) {
          this.steps[i].status = false;
        }
        try {
          this.dataManagementServices
            .deleteCache(this.dataSourceName, 'save')
            .subscribe({
              next: (response) => {
                console.debug(response);
              },
              error: (error) => {
                console.debug(error);
              },
            });
        } catch (error) {
          console.debug(error);
        }
      } else if (data > 0) {
        this.steps[data] = this.getCachedData(this.steps[data]);
      }
      this.changeDetectorRef.detectChanges();
      this.stepper?.next();
    });
  }
}
